export const singleModalTranslationKey = "search_results.static.single_modal"

export const multiModalTranslationKey = "search_results.static.multimodal"